
import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar } from 'lucide-react';

const FinalCTA: React.FC = () => {
  return (
    <section className="py-16 bg-[#8B4513] text-white" aria-labelledby="final-cta-heading">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-montserrat font-bold mb-6" id="final-cta-heading">
          Ready to discover NYC's feline history?
        </h2>
        <p className="text-lg md:text-xl max-w-2xl mx-auto mb-8">
          Book your spot today and experience New York City like never before!
        </p>
        <Link 
          to="/booking" 
          className="bg-[#C46829] hover:bg-[#B35718] hover:text-white text-white px-10 py-4 rounded-lg text-lg font-montserrat font-semibold transition-all duration-300 hover:scale-105 hover:shadow-xl inline-flex items-center shadow-lg min-w-[200px] min-h-[48px] justify-center"
          aria-label="Book your tour now"
        >
          <Calendar size={22} className="mr-3" aria-hidden="true" />
          Book Your Tour – Only $40!
        </Link>
      </div>
    </section>
  );
};

export default FinalCTA;
